module.exports = __webpack_public_path__ + "img/camera_1.325abffa.jpg";